export enum Tabs {
    PRIMARY_USER = "PRIMARY USER",
    SECONDARY_USER = "SECONDARY USER",
}

export enum UserRoute {
    PRIMARY_USER = "primary_user",
    SECONDARY_USER = "secondary_user",
}
